var displayPrice = {
    data: {
        currency: 'USD', 
        currencyDecimals: 2,
        currencyHtml: false
    },
    mounted: function() {
        this.currency = win.store.state.query.cur || win.store.state.currency;
    },
    methods: {
        price: function(amount, currency) {
	        if (currency) {
                this.currency = currency;
            }

            var display = win.store.state.currencyDisplay || {
                    currencyInFront: true,
                    groupingSeparator: ' ',
                    decimalSeparator: '.',
                    currencySpace: true
                },
                amountStr,
                symbols = { "EUR": "€", "GBP": "£", "USD": "$", "ARS": "AR$", "BRL": "R$", "CNY": "¥", "PHP": "Php", "HKD": "HK$", "ILS": "₪", "JPY": "¥", "PLN": "zł", "RUB": "руб", "THB": "฿", "TRY": "TL", "VND": "₫", "ZAR": "R", "KRW": "₩" },
                symbol = symbols[this.currency] || this.currency,
                isNegative = amount < 0,
                decimalPart,
                integerPart,
                groupedIntegerPart,
                splitArr,
                decimals = this.currencyDecimals,
                decimalSeparator = display.decimalSeparator,
                currencySpaceStr = display.currencySpace ? ' ' : '';

            amount = Math.abs(amount);

            if (decimals) {
        		amountStr = (Math.round(amount * Math.pow(10, decimals)) / Math.pow(10, decimals)).toFixed(decimals);
        		splitArr = amountStr.split('.');
        		integerPart = splitArr[0];
        		decimalPart = splitArr[1];
        	} else {
        		integerPart = Math.round(amount).toString();
        	}

        	groupedIntegerPart = display.groupingSeparator ? integerPart.replace(/\B(?=(\d{3})+(?!\d))/g,display.groupingSeparator) : integerPart;

            if (this.currencyHtml) {
            	symbol = '<span class="currency-symbol">'+symbol+'</span>';
            	groupedIntegerPart = '<span class="amount-integer">'+groupedIntegerPart+'</span>';
        		decimalSeparator = '<span class="decimal-separator">'+decimalSeparator+'</span>';
        		decimalPart = '<span class="amount-decimal">'+decimalPart+'</span>';
            } 

            amountStr = groupedIntegerPart + (decimals ? (decimalSeparator + decimalPart) : '');

            var fullStr = (isNegative ? '- ' : '');
            if (display.currencyInFront) {
                fullStr += symbol + currencySpaceStr + amountStr;
            } else {
                fullStr += amountStr + currencySpaceStr + symbol;
            }

            return fullStr;
        }
    }
};